import React from "react";

function WhatsAppModal(props) {
  return (
    <div className="whatsapp-modal-container">
      <div
        className="modal fade show"
        id="whatsappModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="whatsappModalCenterTitle"
        aria-modal="true"
        style={{ display: props.show ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ borderRadius: "20px" }}>
            <div className="modal-header">
              <h5 className="modal-title" id="whatsappModalLongTitle">
                WhatsApp anyone
              </h5>
              <button
                type="button"
                className="close"
                onClick={props.onHide}
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    name="whatsapp"
                    id="whatsapp"
                    placeholder="Recipient's 10 digit mobile number"
                    maxLength="10"
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      id="whatsappSubmit"
                    >
                      <i className="fa fa-paper-plane"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsAppModal;
